const dataRoadmap = [
    {
        id: 1,
        time: 'Q4 2022',
        list: [
            {
                text: 'Release website and logo'
            },
            {
                text: 'IDO listing'
            },
            {
                text: 'Launch the project'
            },
            {
                text: 'Pancake listing'
            },
        ],
        positon: 'left',
        style: 'normal'
    },
    {
        id: 2,
        time: 'Q4 2022',
        list: [
            {
                text: 'Complete NFT marketplace'
            },
            {
                text: 'Grow community'
            },
            {
                text: 'Get More Holders'
            },
            {
                text: 'Small CEX listing'
            },
        ],
        positon: 'right',
        style: 'normal'
    },
    {
        id: 3,
        time: 'Q1 2023',
        list: [
            {
                text: 'Website improvement'
            },
            {
                text: 'The Vault is large'
            },
            {
                text: 'Second NFT Release'
            },
            {
                text: 'Merging the NFT'
            },
        ],
        positon: 'left'
    },
    {
        id: 4,
        time: 'Q2 2023',
        list: [
            {
                text: 'The final version of the website'
            },
            {
                text: 'GameFi release'
            },
            {
                text: 'More CEX listing'
            },
            {
                text: 'BUSD Vault Metaverse preparing'
            },
        ],
        positon: 'right'
    },
    {
        id: 5,
        time: 'Q3 2023',
        list: [
            {
                text: 'TO'
            },
            {
                text: 'BE'
            },
            {
                text: 'CONTINUED'
            },
            {
                text: 'Not the end, it is just a start'
            },
        ],
        positon: 'left'
    },
]

export default dataRoadmap;